"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mixpanel = require("mixpanel-browser");
const state_1 = require("@airstudio/state");
class Mixpanel extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'mixpanel';
        state_1.Bus.onConfigReady(({ mixpanel: key }) => {
            if (!key) {
                // tslint:disable-next-line: no-console
                return console.warn('Mixpanel extension is activated but backend config did not provide a `mixpanel` value');
            }
            mixpanel.init(key);
            this.dispatchSuccess({});
        });
        state_1.Bus.onUserReady(({ userId }) => {
            if (!mixpanel) {
                return;
            }
            mixpanel.identify(userId);
        });
        state_1.Bus.onAnalytics(({ eventName, args, value }) => {
            if (!mixpanel) {
                return;
            }
            mixpanel.track(eventName, args);
            if (value) {
                mixpanel.people.track_charge(value);
            }
        });
    }
}
exports.Mixpanel = Mixpanel;
//# sourceMappingURL=index.js.map